import React, {Component} from 'react';
import {connect} from 'react-redux';
import FilterInput from './filter-input';
import FilterSlider from './filter-slider';

class LineupsQuantity extends Component {
    render() {
        const {sportConfig, useDragging} = this.props;

        if (sportConfig.isModeLateswap()) {
            return null;
        }

        return (
            <div className="filters-cell lineups-cell">
                <div className="filter-group">
                    <strong className="filter-title"># of lineups</strong>
                    <div className="range-holder">
                        <div className="slider-wrap">
                            <FilterSlider step={1} useDragging={useDragging} />
                        </div>
                        <div className="range-wrap">
                            <FilterInput testId="lineups-number-input" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;

    return {
        sportConfig,
    };
}

export default connect(mapStatesToProps)(LineupsQuantity);
